export default __webpack_public_path__ + "static/media/bnb.560cf412.png";